<template>
  <!-- No Gyaan only Gain -->
    <div id="ngog">
      <b-container fluid class="bv-example-row">
        <b-row>
          <b-col sm="12" lg="6" class="gradient1">
            <b-img :src="images.ngog" id="ngog-img" fluid alt="NGOG Image"></b-img>
          </b-col>
          <b-col sm="12" lg="6" class="ngog2"> 
            <cq-headings headingtext="" white="true">1000+ Enterpreneurs have Gained massively </cq-headings>
            <cq-btn class="inverse" :inverse="true"><b>SEE FOR YOURSELF</b></cq-btn>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <!-- End No Gyaan Only Gain -->
</template>

<script>
import CQHeadings from '../../components/ui/CQHeadings.vue'
import CQButton from '../../components/ui/CQButton.vue'

// Import Images
import ngog from '../../assets/image/home/ngog.png'

export default {
    components: {
        'cq-headings' : CQHeadings,
        'cq-btn' : CQButton
    },
    data() {
        return {
            images: { 
                ngog
            }
        }
    }
}
</script>

<style scoped>
#ngog{
  text-align: center;
}

#ngog >>> .gradient1{
  background-image: linear-gradient(rgba(255,255,255,.9), rgba(255,255,255,.5)), url(../../assets/image/home/ngogbg.png);
  background-repeat: no-repeat;
  background-size: cover;
}

#ngog >>> .gradient1 img{
  padding: 15%;
}

#ngog >>> .ngog2{
  background-color: var(--primary-color);
  padding-top: 100px;
}
#ngog >>> .inverse{
  padding-top: inherit;
}


/* Mobile View */
@media only screen and (max-width: 992px){
    #ngog >>> .ngog2{
    padding: 70px;
  }
}

/* Desktop View */
@media only screen and (min-width: 992px){
  #ngog{
    border-top: 5px solid var(--primary-color);
    text-align: center;
  }
}
</style>